var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',{staticClass:"align-items-center",attrs:{"no-gutters":""}},[_c('h1',{staticClass:"col"},[_vm._v("Novos Arquivos")])]),_c('list-files',{attrs:{"inGalery":true},on:{"saved":_vm.saved}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }